const stats = [
  { value: '20000+', label: '影视资源', icon: 'ri-movie-2-line' },
  { value: '500万+', label: '活跃用户', icon: 'ri-user-star-line' },
  { value: '99.9%', label: '流畅播放率', icon: 'ri-speed-up-line' },
  { value: '24h', label: '全天候更新', icon: 'ri-timer-flash-line' },
];

export default function StatsSection() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-12">
      <div className="max-w-[900px] mx-auto">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-8">
          我们的成就
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-background-100 rounded-xl p-6 text-center"
            >
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                <i className={`${stat.icon} text-2xl text-primary-500`}></i>
              </div>
              <p className="text-2xl md:text-3xl font-heading font-black text-foreground-900 mb-1">
                {stat.value}
              </p>
              <p className="text-xs text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}